import { cloneDeep } from 'lodash'

import { Services, joinURLPath } from '@sigma-frontend-libs/commons'
import { TaskStates } from '@sigmasms/shared-types'

import { getHammerTime, globalErrorHandler, permissionPresets, request } from '@/utils'

import render from './render'

const defaultDate = {
  date: undefined,
  time: getHammerTime()
}

export default {
  name: 'TaskUpdateStateButton',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      loading: false,
      showDialog: false,

      changeableDate: cloneDeep(defaultDate)
    }
  },

  computed: {
    canUpdateTasksAsMeUp() {
      return this.checkPermissions(`advanced.${Services.tasks}.update`, permissionPresets.meUp)
    },

    computedDate() {
      if (this.changeableDate.date) {
        return new Date(this.changeableDate.date + 'T' + this.changeableDate.time)
      }

      return null
    }
  },

  methods: {
    async updateTask(id, state, startsAt = null) {
      if (this.value.state !== TaskStates.stopped) {
        try {
          this.loading = true
          await request.update(joinURLPath(Services.tasks, id), {
            body: {
              state,
              startsAt
            }
          })
          this.addSnackbar({
            text: this.getTranslate(`${Services.tasks}.snackbars.updated`),
            type: 'success'
          })
        } catch (error) {
          globalErrorHandler(error)
        } finally {
          this.loading = false
        }
      }
    }
  },

  render
}
